import React from 'react';
import { Translations } from '../i18n/translations';
import { WhatsAppIcon } from './icons';
interface StickyMobileBarProps {
  t: Translations;
  isVisible: boolean;
}
export const StickyMobileBar: React.FC<StickyMobileBarProps> = ({
  t,
  isVisible
}) => {
  if (!isVisible) return null;
  return <div className="lg:hidden fixed bottom-0 left-0 w-full bg-cream border-t border-gold/20 p-4 z-50 shadow-[0_-4px_20px_rgba(0,0,0,0.05)]" data-id="element-334">
      <div className="flex space-x-3" data-id="element-335">
        <button className="flex-1 bg-gold text-ink h-12 text-xs uppercase tracking-widest hover:bg-gold-dark transition-soft rounded-sm font-medium" data-id="element-336">
          {t.bestSellers.addToRecovery}
        </button>
        <button className="w-12 h-12 border border-gold text-gold flex items-center justify-center rounded-sm hover:bg-gold hover:text-ink transition-soft" data-id="element-337">
          <WhatsAppIcon className="w-5 h-5" data-id="element-338" />
        </button>
      </div>
    </div>;
};